import React from 'react';
import { canUseDOM } from 'exenv';

const Dianomi = () => {
  if (canUseDOM && !window.dianomiContextHost) {
    const script = document.createElement('script');
    script.src = 'https://www.dianomi.com/js/contextfeed.js?id=76';
    script.async = true;
    document.body.append(script);
  }

  return (
    <section className="more-stories-module post-more-stories">
      <div className="topBar" />

      <div
        className="dianomi_context dianomiScriptContainer"
        data-dianomi-context-id="76"
      />
    </section>
  );
};

export default Dianomi;
